export const BUSINESS = {
  name: 'Plote Professional Services LLC',
  shortName: 'Plote Professional Services',
  phoneDisplay: '(602) 803-7805',
  phoneHref: 'tel:+16028037805',
  region: 'Serving the Greater Phoenix Metro, Arizona',
  facebook: 'https://www.facebook.com/ploteprosvcs/',
  instagram: 'https://www.instagram.com/ploteprosvcs/',
  maps: 'https://maps.app.goo.gl/7VoiQPmSBGxuKCDZ7',
  logoWhite:
    'https://cdn.magicpatterns.com/uploads/veN6jQUS9UQsnBrZFpBSjq/Plotes-Professional-Services-Logo-wide-white-1.png',
} as const

export const IMAGES = {
  planting: 'https://cdn.magicpatterns.com/uploads/jeWLq9cpCA2tYq9CQTvKeC/plote4.jpg',
  pergola: 'https://cdn.magicpatterns.com/uploads/tLf5drWjHbFVZjSF1gPReG/plote3.jpg',
  patio: 'https://cdn.magicpatterns.com/uploads/5oN67XA9nfVG8Ehdr39TTP/plote2.jpg',
  frontyard: 'https://cdn.magicpatterns.com/uploads/1fPXDiFAA1CRT1dT2d63ZV/plote1.jpg',
} as const

export const NAV_LINKS = [
  { label: 'Services', href: '#services' },
  { label: 'Why Us', href: '#why-us' },
  { label: 'Gallery', href: '#gallery' },
  { label: 'Reviews', href: '#reviews' },
  { label: 'Contact', href: '#contact' },
] as const
